/**
 * ChatImageBubble — renders a photo message in the chat stream.
 *
 * Styling follows iMessage pattern: width-constrained, aspect-ratio-aware with height cap.
 * Sent/received alignment uses existing bubble pattern (flex-end vs flex-start).
 */
const ChatImageBubble = ({ url, isSent, uploading, uploadFailed, onRetry }) => {
  return (
    <>
      <style>{`@keyframes chat-image-spin { to { transform: rotate(360deg); } }`}</style>
      <div
        style={{
          display: 'flex',
          justifyContent: isSent ? 'flex-end' : 'flex-start',
          width: '100%',
          padding: '2px 12px',
        }}
      >
        <div
          style={{
            position: 'relative',
            maxWidth: '85%',
            cursor: uploadFailed ? 'pointer' : 'default',
          }}
          onClick={uploadFailed ? onRetry : undefined}
        >
          <img
            src={url}
            alt="Shared photo"
            loading="lazy"
            style={{
              display: 'block',
              width: '100%',
              maxHeight: '60vh',
              objectFit: 'cover',
              borderRadius: isSent ? '18px 18px 0 18px' : '18px 18px 18px 0',
            }}
          />
          {/* Upload in progress overlay */}
          {uploading && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: isSent ? '18px 18px 0 18px' : '18px 18px 18px 0',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
              }}
            >
              <div
                style={{
                  width: '28px',
                  height: '28px',
                  border: '3px solid rgba(255, 255, 255, 0.3)',
                  borderTopColor: 'white',
                  borderRadius: '50%',
                  animation: 'chat-image-spin 0.8s linear infinite',
                }}
              />
            </div>
          )}
          {/* Upload failed overlay */}
          {uploadFailed && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: isSent ? '18px 18px 0 18px' : '18px 18px 18px 0',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
              }}
            >
              <div
                style={{
                  color: 'white',
                  fontSize: '13px',
                  fontWeight: 500,
                  textAlign: 'center',
                  padding: '8px',
                }}
              >
                Tap to retry
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatImageBubble;
